import { loadGoogleApis } from '../../../../../main/src/scripts/lib/loadGoogleApis'

let geocache = {}
try {
  geocache = JSON.parse(localStorage.getItem('geocache')) || {}
} catch (e) {
  console.error(e)
}

let geocoder

async function loadGeocoder() {
  const google = await loadGoogleApis()

  if (!geocoder) {
    geocoder = new google.maps.Geocoder()
  }

  return geocoder
}

export async function getLocationCoordinates(address) {
  if (!geocache[address]) {
    try {
      await loadGeocoder()

      const { results } = await geocoder.geocode({ address, region: 'CH' })

      if (results?.length) {
        const result = results[0]
        const { geometry } = result
        const lat = geometry.location.lat?.()
        const lng = geometry.location.lng?.()
        geocache[address] = { lat, lng }
        localStorage.setItem('geocache', JSON.stringify(geocache))
      }
    } catch (e) {
      console.error(e)
    }
  }

  return geocache[address]
}

export default getLocationCoordinates
